export default __webpack_public_path__ + "static/media/986.25263387.png";